import React from 'react';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js';
import { Bar } from 'react-chartjs-2';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

function StackedBarChart({ data, headerActionCallback, title, isLarge }) {
  const { t } = useTranslation();

  const options = {
    plugins: {
      legend: {
        display: false
      }
    },
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: {
        stacked: true,
        grid: {
          display: false
        },
        ticks: {
          color: '#5C6370',
          font: {
            size: 10
          }
        }
      },
      y: {
        stacked: true,
        ticks: {
          color: '#5C6370',
          font: {
            size: 10
          }
        }
      }
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        width: '100%',
        overflow: isLarge && data ? 'auto' : 'unset',
        paddingTop: isLarge && data ? '25px' : 'unset'
      }}
    >
      <Typography
        color="#00010E"
        fontSize={20}
        fontWeight={600}
        fontFamily={'Mulish'}
        letterSpacing="0.01938em"
        lineHeight="22px"
        sx={{
          ml: headerActionCallback ? '10px' : 0,
          mb: 2,
          position: isLarge && data ? 'absolute' : 'unset',
          top: '25px'
        }}
      >
        {t(`telemetry.${title}`)}
      </Typography>
      <Box sx={{ flexGrow: 1, width: '100%' }}>
        <Box
          sx={{
            width: isLarge && data ? '2000px' : '100%',
            position: 'relative',
            minHeight: '200px',
            maxHeight: '200px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between'
          }}
        >
          {data ? (
            <Bar data={data} options={options} />
          ) : (
            <Typography
              color="lightgrey"
              fontSize={20}
              position={'absolute'}
              fontWeight={600}
              fontFamily={'Mulish'}
              letterSpacing="0.01938em"
              lineHeight="22px"
              left={'50%'}
              top={'36%'}
              sx={{ ml: headerActionCallback ? '10px' : 0, transform: 'translate(-50%, -50%)' }}
              textAlign={'center'}
            >
              {t('telemetry.noData')}
            </Typography>
          )}
        </Box>
      </Box>
    </Box>
  );
}

StackedBarChart.propTypes = {
  data: PropTypes.any,
  headerActionCallback: PropTypes.func,
  title: PropTypes.string.isRequired,
  isLarge: PropTypes.bool
};

export { StackedBarChart };
